import React from 'react'
import {  properties } from '../data'
import { FaLocationDot } from 'react-icons/fa6'
import { LuBedDouble } from 'react-icons/lu'
import { BiArea } from 'react-icons/bi'
import "./Properties.css"

import { useNavigate } from 'react-router-dom'
import Hero from './Hero'
import Footer from './Footer'

const Properties = () => {
  const navigate=useNavigate()
  const handleNavigation=(id) =>{
    navigate(`/properties/${id}`)
  }
  return (
    <>
      <Hero style={{height:"auto"}} />
      <div className='conatiner'>
       
        

        <div className='properties-container'>
          <div className='properties'>
            {properties.map((property)=>(
              
              <div key={property.id} className='card-container' onClick={() => handleNavigation(property.id)}>
                <img src={property.image} alt='' className='card-image'/>
                <div className='card-badge'>
                  <span className='card-type'>{property.title}</span>
                </div>
                <div className='card-content'>
                  <span className='card-type'>{property.type}</span>
                  <span className='card-price'>{property.price}</span>
                  <span className='card-address'>
                    <FaLocationDot className='card-icon'/>
                    {property.address}
                  </span>

                  <div className='card-rooms'>
                    <span>
                      <LuBedDouble className='card-icon'/>
                      {property.bedrooms}
                    </span>
                    <span>
                      <BiArea className='card-icon'/>
                      {property.size} (sqm)
                    </span>
                  </div>

                </div>
              </div>
            ))}
          </div>
        </div>
      </div> 
      <Footer/>
    </>
    
  )
}

export default Properties
